import React from 'react';

import { CommonFilterProps } from './types';
import { FilterList } from './FilterSideDrawerContent.style';
import { FilterSortBy } from './FilterSortBy';
import { FilterItem } from './FilterItem';

interface FilterSideDrawerContentProps extends CommonFilterProps {
  filterMenuList: any[];
}

export const FilterSideDrawerContent: React.FC<FilterSideDrawerContentProps> = ({
  activeFilter,
  filterMenuList,
  updateFilter,
  searchFilters,
}) => {
  if (activeFilter === null) return null;

  return (
    <FilterList>
      <FilterSortBy
        activeFilter={activeFilter}
        updateFilter={updateFilter}
        searchFilters={searchFilters}
      />
      {filterMenuList.map((filter, index) => (
        <FilterItem
          key={index}
          filter={filter}
          updateFilter={updateFilter}
          activeFilter={activeFilter}
          searchFilters={searchFilters}
        />
      ))}
    </FilterList>
  );
};
